<template>
  <div class="login">
    <navbar></navbar>
    <p></p>

    <div class="card" style="width: 20rem;">
      <div class="card-block">
        <h4 class="card-title">Please sign in</h4>
        <label for="inputEmail" class="sr-only">Email address</label>
        <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus v-model="credentials.username">
        <label for="inputPassword" class="sr-only">Password</label>
        <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="credentials.password">
        <input type="checkbox" id="rememberpassword" class="form-control" v-model="Remember" /> <label for="rememberpassword" >Remember password</label>
        <div>
           <b-alert variant="danger" v-if="loginfailed" show>Login failed</b-alert>
        </div>
        <button class="btn btn-primary" v-on:click="login()">Sign in</button>
      </div>
    </div>



  </div>
</template>

<script>

import Vue from 'vue';
import navbar from './navbar.vue';

export default {
  name: 'login',
  data () {
    return {
        credentials:
        {
          username : "",
          password : ""
        },
        loginfailed: false,
        Remember : false,
    }
  },
  methods: {
    login : function() {
      this.$http.post('pLoginUser', this.credentials).then(function(response) {
        if (response.data[0].Token == null || response.data[0].Token == "")
        {
          this.loginfailed = true;
          if (this.Remember)
            window.localStorage.setItem('authUser', null);
          else
            window.sessionStorage.setItem('authUser', null);
        }
        else 
        {
          Vue.http.headers.common['Authorization'] = 'Basic ' + btoa(this.credentials.username + ":" + this.credentials.password); 
          this.loginfailed = false;
          if (this.Remember)
            window.localStorage.setItem('authUser', JSON.stringify(this.credentials));
          else
            window.sessionStorage.setItem('authUser', JSON.stringify(this.credentials));
          var url = this.$route.params.returnpath;
          this.$router.push({ path: url});
        }
      });
    }
  },
  created: function() {
    var lsUser = JSON.parse(window.localStorage.getItem('authUser'));
    if (lsUser) 
    {
      this.Remember = true;
      this.credentials.username = lsUser.username;
      this.credentials.password = lsUser.password;
      this.login();
    } else {
      var ssUser = JSON.parse(window.sessionStorage.getItem('authUser'));
      this.credentials.username = ssUser.username;
      this.credentials.password = ssUser.password;
      this.login();
    };
  },
  components: {
    'navbar': navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// login.vue?32383527